module.exports = __webpack_public_path__ + "static/media/bg-shape.49213c49.png";